module.exports = __webpack_public_path__ + "static/media/lego3.06be6044.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lego3.png
// module id = 290
// module chunks = 0